import Switch from "@mui/material/Switch";
import { styled, TextField, Typography } from "@mui/material";
import React from "react";

const FlagRow = styled("div")(({ greyed }: any) => ({
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  alignItems: "center",
  opacity: greyed === "true" ? "0.4" : "1",
}));
const TextInput = styled(TextField)({
  paddingLeft: "1em",
  marginLeft: "2em",
});
export function FeatureFlagController(props: {
  name: string;
  value: any;
  label: string;
  handleFeaturesChange: (type: "checked" | "value") => any;
  greyed?: boolean;
}) {
  const { name, value, label, handleFeaturesChange, greyed } = props;
  const isBool = typeof value === "boolean";
  const isNumber = typeof value === "number" || !isNaN(parseFloat(value));
  if (isBool) {
    return (
      <FlagRow greyed={greyed.toString()}>
        <Typography variant="body1">{label}</Typography>
        <Switch
          checked={value}
          onChange={handleFeaturesChange("checked")}
          name={name}
        />
      </FlagRow>
    );
  } else {
    return (
      <FlagRow greyed={greyed.toString()}>
        <Typography variant="body1">{label}</Typography>
        <TextInput
          fullWidth={!isNumber}
          name={name}
          id="outlined-number"
          // label={label}
          type={isNumber ? "number" : undefined}
          value={value}
          onChange={handleFeaturesChange("value")}
        />
      </FlagRow>
    );
  }
}
